/**
 * Created by yarik on 18.7.17.
 */
import lazyLoading from './lazyLoading'

export default {
  name: 'driverPagos',
  meta: {
    expanded: false,
    title: 'Listado de Pagos',
    iconClass: 'vuestic-icon vuestic-icon-auth'
  },
  children: [
    {
      name: 'driverPagos',
      path: '/driverpagos/:driverId',
      component: lazyLoading('app/driver/Pagos'),
      meta: {
        title: 'Pagos',
        requiresAuth: false
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/driverPagos.js